export default "__VITE_ASSET__b5b6a474__"